export default __webpack_public_path__ + "static/media/ai-machine-learning.5bf2eb68.jfif";